module.exports = __webpack_public_path__ + "4a0988088b17549720fe7d40647b7c03.png";